module.exports = __webpack_public_path__ + "assets/img/15_407_big.bb0c1f55.jpg";